export default _ => {
  return encodeURIComponent(window.location.href);
}



/** WEBPACK FOOTER **
 ** ./app/utils/getCurrentEncodedUrl.js
 **/